import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';

import { shouldShowChallenge } from '../utils/homeState.mjs';
import { formatUnreadCount } from '../utils/unreadCounts.mjs';

export default {
  view(vnode) {
    if (!shouldShowChallenge(app.store.all('tags'))) return null;

    const translationPrefix = 'yingtao-forum-homepage.forum.challenge';
    const unreadCount = Number(vnode.attrs.unreadCount) || 0;

    return (
      <section className="YingtaoChallenge" aria-labelledby="yingtao-challenge-title">
        <div>
          <p className="YingtaoChallenge-eyebrow">{app.translator.trans(`${translationPrefix}.eyebrow`)}</p>
          <h2 id="yingtao-challenge-title">
            <span>{app.translator.trans(`${translationPrefix}.title`)}</span>
            {unreadCount > 0 ? (
              <span
                className="YingtaoUnreadBadge"
                aria-label={app.translator.trans('yingtao-forum-homepage.forum.unread_label', {
                  count: unreadCount,
                })}
              >
                {formatUnreadCount(unreadCount)}
              </span>
            ) : null}
          </h2>
          <p className="YingtaoChallenge-description">
            {app.translator.trans(`${translationPrefix}.description`)}
          </p>
        </div>
        <LinkButton
          href={app.route('tag', { tags: 'quarterly-challenge' })}
          icon="fas fa-trophy"
          className="Button YingtaoButton YingtaoButton--challenge"
        >
          {app.translator.trans(`${translationPrefix}.action`)}
        </LinkButton>
      </section>
    );
  },
};
